import { AbstractQuery } from '../query';

export class LoadTheUserInterfaceStatesForTheUserQuery extends AbstractQuery {
	public readonly name = 'IFS\\StateProvider\\Query\\Queries\\LoadTheUserInterfaceStatesForTheUserQuery';

	constructor() {
		super();
		this.parameters = [];
		this.cacheable = false;
		this.subscribeForUpdates = false;
	}
}
